"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var ReportProblemOutlined_1 = __importDefault(require("@material-ui/icons/ReportProblemOutlined"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var ErrorMessage = function (_a) {
    var theme = _a.theme, errors = _a.errors, ticketIndex = _a.ticketIndex;
    var classes = (0, styles_1.styles)(theme)();
    var errorList = [];
    if (Array.isArray(errors)) {
        errorList = errors;
    }
    else if (errors != null) {
        errorList = [errors];
    }
    var filteredErrors = errorList.filter(function (e) { return typeof (e === null || e === void 0 ? void 0 : e.value) === 'string' && e.value.trim() !== ''; });
    return (react_1.default.createElement("div", { key: "".concat(filteredErrors.length), style: { paddingBottom: theme.spacing() } },
        ticketIndex && react_1.default.createElement(core_1.Typography, { variant: "srOnly" }, "Ticket - ".concat(ticketIndex, ".")),
        filteredErrors.map(function (error) { return (react_1.default.createElement("div", { key: "".concat(filteredErrors.length, "-").concat(error.key, "-").concat(error.value), className: classes.errorContainer },
            react_1.default.createElement(ReportProblemOutlined_1.default, { fontSize: 'small', className: classes.iconLabelError }),
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.errorText }, error.value))); })));
};
exports.default = ErrorMessage;
//# sourceMappingURL=ErrorMessages.js.map